export const SET_HISTORIC_PRO_FOLDER = 'SET_HISTORIC_PRO_FOLDER';
export const SET_ACTIVE_PRO_FOLDER = 'SET_ACTIVE_PRO_FOLDER';
